// Monthly subscription pricing for medspa / salon / spa software.
// Anchored to African market rates (Kenya Prim/Ratibba/Vega ~KES 1.5k–9.5k)
// and US salon SaaS norms (~$25–$100/mo), with purchasing-power aligned NG/GH amounts.

export const BILLING_CYCLES = [
  { id: 'monthly', label: 'Monthly', months: 1 },
  { id: 'yearly', label: 'Yearly', months: 12, discountLabel: '2 months free' },
];

export const PRICING_PLANS = [
  {
    id: 'starter',
    name: 'Starter',
    tagline: 'For solo therapists and single-chair studios.',
    cta: 'Start free trial',
    highlighted: false,
    features: [
      'Online booking link',
      'Calendar & appointments',
      '1 location',
      'Up to 2 staff',
      'Client profiles',
      'Mobile money, card & cash checkout',
      'Day-end till totals',
    ],
    prices: {
      US: 29,
      KE: 2500,
      NG: 18000,
      GH: 200,
    },
  },
  {
    id: 'growth',
    name: 'Growth',
    tagline: 'For busy medspas and multi-chair teams.',
    cta: 'Start free trial',
    highlighted: true,
    features: [
      'Everything in Starter',
      'Up to 10 staff',
      'Front desk & walk-in queue',
      'Deposits & no-show protection',
      'Staff schedules & commissions',
      'WhatsApp / SMS reminders*',
      'Reports & client history',
    ],
    prices: {
      US: 59,
      KE: 5000,
      NG: 38000,
      GH: 380,
    },
  },
  {
    id: 'studio',
    name: 'Studio',
    tagline: 'For multi-location medspas and salon groups.',
    cta: 'Talk to sales',
    highlighted: false,
    features: [
      'Everything in Growth',
      'Unlimited staff',
      'Multi-location management',
      'Shared client book across branches',
      'Marketing & memberships tools',
      'Priority onboarding support',
      'Custom roles & permissions',
    ],
    prices: {
      US: 99,
      KE: 9500,
      NG: 72000,
      GH: 720,
    },
  },
];

export const getPlanPrice = (plan, countryCode, billingCycle = 'monthly') => {
  const code = plan.prices[countryCode] != null ? countryCode : 'US';
  const monthly = plan.prices[code];
  if (billingCycle === 'yearly') {
    // 10 months billed annually ≈ 2 months free
    return monthly * 10;
  }
  return monthly;
};

export const getDisplayedMonthly = (plan, countryCode, billingCycle = 'monthly') => {
  const code = plan.prices[countryCode] != null ? countryCode : 'US';
  const monthly = plan.prices[code];
  if (billingCycle === 'yearly') {
    return Math.round((monthly * 10) / 12);
  }
  return monthly;
};
